import { createContext, useCallback, useContext, useReducer } from "react";

import familyRegActions from "./actions";

const FamilyRegistrationContext = createContext();

const initialState = {
  // TODO: remove these when ready
  userCanViewFamilyRegistrationPanel: false,
  canViewFamilyRegistrationAdminPanel: false,
  networkHasFNC: false,
  // networkHasFundIt: false,

  userIsSuperAdmin: false,
  familyRegistrationIsLive: false,
  networkHasFamilyRegistration: false,
  networkHasFundIt: false,
  networkHasMembershipStatus: false,
  canEditMembershipStatusOptions: false,

  familyRegistrationSettings: null,
  selectedPanel: "welcome",
  textboxes: {
    introductionMessage: null,
    closingMessage: null,
  },
};

const reducer = (state, action) => {
  const { type, adminSettings } = action;
  switch (type) {
    case familyRegActions.SET_ADMIN_SETTINGS:
      return { ...state, ...adminSettings };
    case "setState":
      return { ...state, ...action.payload };
    case "setPanel":
      return { ...state, selectedPanel: action.payload };
    case "setIntroMessage":
      return {
        ...state,
        textboxes: { ...state.textboxes, introductionMessage: action.payload },
      };
    case "setClosingMessage":
      return {
        ...state,
        textboxes: { ...state.textboxes, closingMessage: action.payload },
      };
    case "setRegistrationGroupsAdultAvailableGroups": {
      let newState = { ...state };
      newState.familyRegistrationSettings.registrationGroupAdults.availableGroups =
        action.payload;
      return newState;
    }
    case "setRegistrationGroupsChildrenAvailableGroups": {
      let newState = { ...state };
      newState.familyRegistrationSettings.registrationGroupChildren.availableGroups =
        action.payload;
      return newState;
    }
    case "setSetting": {
      let newState = { ...state };
      newState.familyRegistrationSettings = {
        ...newState.familyRegistrationSettings,
        ...action.payload,
      };
      return newState;
    }

    case "turnOffCompletionNotifications": {
      // payload is an array of admin IDs that were successfully updated
      let newState = { ...state };
      newState.familyRegistrationSettings.finishedNotificationRecipients.users =
        newState.familyRegistrationSettings.finishedNotificationRecipients.users.map(
          (admin) => {
            if (admin.enabled && action.payload.includes(admin.ID)) {
              admin.enabled = false;
            }
            return admin;
          }
        );
      return newState;
    }
    default:
      return state;
  }
};

function FamilyRegistrationProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setState = useCallback(
    (payload) => dispatch({ type: "setState", payload }),
    [dispatch]
  );

  const setFamilyRegistrationSettings = (familyRegistrationSettings) =>
    dispatch({ type: "setState", payload: { familyRegistrationSettings } });

  return (
    <FamilyRegistrationContext.Provider
      value={{
        state,
        dispatch,
        setState,
        setFamilyRegistrationSettings,
      }}
    >
      {children}
    </FamilyRegistrationContext.Provider>
  );
}

function useFamilyRegistrationContext() {
  const context = useContext(FamilyRegistrationContext);
  if (context === undefined) {
    throw new Error(
      `useFamilyRegistrationContext must be used within the FamilyRegistrationProvider`
    );
  }
  return context;
}

export { FamilyRegistrationProvider, useFamilyRegistrationContext };
